var render, staticRenderFns
import script from "./dynamic-template.ts?vue&type=script&lang=ts&external"
export * from "./dynamic-template.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2250ac",
  null
  
)

export default component.exports